import { AnyRoute, createRoute, lazyRouteComponent, notFound } from '@tanstack/react-router'
import { ApiError } from 'commons/types'
import { isEqual } from 'lodash'
import { getListWebpage } from '~bank-bsa-reporting/service/sar'
import { SarList } from '~bank-bsa-reporting/types'

import { SarListSchema } from './SarListSchema'

export const ListRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `/`,
    component: lazyRouteComponent(() => import('./List')),
    validateSearch: (search) => SarListSchema.parse(search),
    loaderDeps: (all) => ({
      search: all.search,
      isChanged: !isEqual(SarListSchema.parse({}), all.search)
    }),
    loader: async ({ deps: { search } }) => {
      let sars: SarList
      try {
        sars = await getListWebpage(search)
      } catch (e: unknown) {
        if (e instanceof ApiError && e.httpCode === 400) {
          throw notFound()
        }
        throw e
      }
      return sars
    }
  })
